import * as React from 'react';
import {Table} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import {Invoice} from '../api/dtos/dtos';
import locales from '../locales';
import {formatDateTimeOrNull} from '../utils/date-utils';
import {renderInvoiceType} from './invoice';
import {simpleColumn} from "../utils/table-utils";
import {Link} from 'react-router-dom';
import {viewInvoicePath} from '../paths';

export default function InvoiceHistoryTable({invoices}: {invoices?: Invoice[]}) {
  const columns: Array<ColumnProps<Invoice>> = [
    simpleColumn(locales.invoice_number, invoice => (
      <Link to={viewInvoicePath(invoice.id)}>
        {invoice.externalNumber ?? invoice.internalNumber ?? '-'}
      </Link>
    )),
    simpleColumn(locales.type, i => renderInvoiceType(i.type)),
    simpleColumn(locales.created_at, i => formatDateTimeOrNull(i.createdAt) || '-'),
  ];
  return (
    <Table
      dataSource={invoices ?? []}
      columns={columns}
      rowKey="id"
      bordered={true}
      size="small"
      pagination={false}
      scroll={{x: 600}}
    />
  );

}



// WEBPACK FOOTER //
// ./src/invoicing/InvoiceHistoryTable.tsx